






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Option, OptionValue } from '@/entities/rain/dropdown'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

@Component<Dropdown>({
    model: {
        prop: 'value',
        event: 'change'
    },
    components: {
        FontAwesomeIcon
    }
})
export default class Dropdown extends Vue {
    @Prop({ type: Array, required: false, default: [] })
    readonly options!: Option[]

    @Prop({ type: String, required: false, default: '' })
    readonly value!: OptionValue

    @Prop({ type: String, required: false, default: '' })
    readonly label!: string

    @Prop({ type: Boolean, required: false, default: false })
    readonly disabled!: boolean

    @Prop({ type: Boolean, required: false, default: false })
    readonly error!: boolean

    faChevronDown = faChevronDown
}
